import { useEffect, useState } from "react";
import { SubscriptionLandingInfo } from "../../types/Paywall";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

type Options = {
  communityId?: string;
};

export const useAllPaywalls = ({ communityId }: Options = {}) => {
  const [paywalls, setPaywalls] = useState<SubscriptionLandingInfo[]>([]);

  useEffect(() => {
    if (!communityId) {
      setPaywalls([]);
      return;
    }

    const docRef = firestore
      .collection(DB_PATH.COMMUNITY)
      .doc(communityId)
      .collection("landingPage")
      .doc("info");

    const unsubscribe = docRef.onSnapshot(
      (doc) => {
        if (doc.exists) {
          const data = doc.data() as SubscriptionLandingInfo;
          setPaywalls([data]);
        } else {
          setPaywalls([]);
        }
      },
      (error) => {
        console.error("Error fetching paywall", error);
        setPaywalls([]);
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return paywalls;
};
